module.exports = __webpack_public_path__ + "img/phone.5a9f6695.svg";